import getVideoConstraints from '../getVideoConstraints'
import isScreenshareTrack from '../isScreenshareTrack'
import isEqual from 'lodash/isEqual'

export interface AmendQualityResponse {
  tracksApplied: number
  error: boolean
}

/**
  * Amends the quality of the local video track relative to the number of presenters in the room
  * @param size - the number of presenters in the room
  * @param videoTracks - a map of Twilio video tracks
  * @param deviceId - the webcam device id to use
  */
export default async (size: number, videoTracks: any, deviceId: string, background = false): Promise<AmendQualityResponse> => {

  const newConstraints = await getVideoConstraints(size, deviceId, background)

  let tracksApplied = 0
  let error = false

  for (const [, videoTrack] of videoTracks) {

    if (isScreenshareTrack(videoTrack)) continue

    const curConstraints = videoTrack.track.mediaStreamTrack.getConstraints()

    if (isEqual(curConstraints, newConstraints)) continue

    try {
      await videoTrack.track.mediaStreamTrack.applyConstraints(newConstraints)
      tracksApplied += 1

    }
    catch (e) {

      error = true

    }

  }

  return {
    tracksApplied,
    error
  }

}
